import WPInput from "./WPInput";
export * from "./WPRangedInput";

export default WPInput;
